import useIntakeData from '../../../services/intakeDataService';

export default function useDiagnosisOptions() {
  const { data } = useIntakeData();
  const diagnosisOptionsServer = data?.diagnoses ?? [];

  const diagnosisOptions = diagnosisOptionsServer?.map((option) => {
    return {
      value: option?.icdCode?.replace(/\./g, ''),
      label: option?.displayTitle ?? option?.diagnosisDescription,
    };
  });

  return diagnosisOptions;
}
